export var LIBPREFIX = 'amplitude-ts';
//# sourceMappingURL=lib-prefix.js.map